<div class="wide">
  <p-table
    #table
    [value]="validatedRows()"
    [loading]="isDataLoading()"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    [paginator]="true"
    (onSort)="onPrimeSortChange($event)"
    (onPage)="onPrimePageChange($event)"
    [totalRecords]="tablePage()?.totalElements || 0"
    [rows]="tablePage()?.size || 10"
    [tableStyle]="{ 'min-width': '50rem' }"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginatorStyleClass]="'customPrimePaginator'"
    [customSort]="true"
    dataKey="id"
  >
    <ng-template #header>
      <tr>
        <th style="width: 25%; font-weight: bold" pSortableColumn="imie">
          <div class="flex items-center gap-2">
            Imię
            <p-sortIcon field="imie" />
          </div>
        </th>
        <th style="width: 25%; font-weight: bold">Nazwisko</th>
        <th style="width: 25%; font-weight: bold">Data urodzenia</th>
        <th style="width: 25%; font-weight: bold">Akcje</th>
      </tr>
    </ng-template>
    <ng-template #body let-user>
      <tr>
        <td>
          <span class="family-member-name">
            {{ user.imie }}
            @if (user.hasValidationErrors) {
              <ng-container *ngTemplateOutlet="validationIcon" />
            }
          </span>
        </td>
        <td>{{ user.nazwisko }}</td>
        <td>{{ user.dataUrodzenia | date: 'yyyy-MM-dd' }}</td>
        <td>
          <div class="flex gap-4">
            <p-button
              type="button"
              (click)="deleteFamilyMemberDialog(user)"
              ariaLabel="Usuń"
              pTooltip="Usuń"
              tooltipPosition="top"
              [rounded]="true"
              [text]="true"
            >
              <i class="pi pi-trash icon" aria-hidden="true"></i>
            </p-button>
            <p-button
              type="button"
              (click)="navigateToEditFamilyMember(user.id)"
              ariaLabel="Edytuj"
              pTooltip="Edytuj"
              tooltipPosition="top"
              [rounded]="true"
              [text]="true"
            >
              <i class="pi pi-pen-to-square icon" aria-hidden="true"></i>
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="flex justify-between items-center mt-2">
    <p-button
      styleClass="customInfoButton"
      label="Dodaj członka rodziny"
      (click)="createFamilyMember()"
    ></p-button>
    <p-button
      styleClass="customInfoButton outlined"
      label="Wstecz"
      (click)="goToHomepage()"
    ></p-button>
  </div>
</div>
<div class="narrow">
  <div class="flex flex-col gap-10">
    <h1>Panel użytkownika</h1>
    <p-button
      styleClass="customInfoButton"
      label="Dodaj członka rodziny"
      (click)="createFamilyMember()"
    ></p-button>
    @for (row of validatedRows(); track row.id) {
      <p-card>
        <div class="flex flex-col">
          <dl>
            <dt class="font-bold">Imię</dt>
            <dd class="family-member-name">
              {{ row.imie }}
              @if (row.hasValidationErrors) {
                <ng-container *ngTemplateOutlet="validationIcon" />
              }
            </dd>
          </dl>
          <hr class="limiter" />
          <app-preview-data-wrapper
            label="Nazwisko"
            [data]="row.nazwisko"
          ></app-preview-data-wrapper>
          <hr class="limiter" />
          <app-preview-data-wrapper
            label="Data urodzenia"
            [data]="row.dataUrodzenia"
            [dataType]="PreviewDataType.DATE"
          ></app-preview-data-wrapper>
          <div class="flex justify-end gap-5 mt-5">
            <p-button
              label="Usuń"
              styleClass="customInfoButton outlined"
              (click)="deleteFamilyMemberDialog(row)"
            />
            <p-button
              label="Edytuj"
              styleClass="customInfoButton outlined"
              (click)="navigateToEditFamilyMember(row.id!)"
            />
          </div>
        </div>
      </p-card>
    }
  </div>
  <p-paginator
    pageLinkSize="3"
    (onPageChange)="onPrimePageChange($event)"
    [rows]="tablePage()?.size"
    [totalRecords]="tablePage()?.totalElements"
    [rowsPerPageOptions]="[10, 20, 30]"
  />
</div>
<ng-template #validationIcon>
  <span
    class="family-member-validation-icon"
    role="img"
    tabindex="0"
    [attr.aria-label]="validationMessage"
    [pTooltip]="validationMessage"
    tooltipPosition="top"
    tooltipEvent="both"
  >
    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <circle cx="10" cy="10" r="9" fill="currentColor" />
      <circle cx="10" cy="6" r="1.2" fill="#fff" />
      <path
        d="M10 9.5V14"
        stroke="#fff"
        stroke-width="2.2"
        stroke-linecap="round"
      />
    </svg>
  </span>
</ng-template>
